export const styles = {
  mainContainer:
    "relative flex flex-col items-center justify-center w-full h-screen bg-center bg-no-repeat bg-cover bg-notFound",
  logoContainer: "absolute flex items-end space-x-2 top-5 left-10",
  logoImg: "w-8 h-8 animate-pulse",
  logoCaption: "text-lg text-blue-200 uppercase",
  backBtn:
    "fixed px-8 py-4 text-lg font-semibold text-white bg-[#06b6d4] rounded-full bottom-36 hover:bg-[#0891b2]",
};
